import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Space} from 'antd';
import {useTranslation} from 'react-i18next';
import TotalCounter from '../TotalCounter';
import {
  StyledTransactionHeaderDetails,
  StyledTransactionHeaderDetailsCombinedCounter,
  StyledTransactionHeaderDetailsUsage
} from './StyledTransactionHeaderDetails';
import DirectionLine from '../../../../SubscriptionsPage/DirectionLine';
import {amountHelpers, objectHelpers, subscriptionsHelpers} from '../../../../../../utils/helpers';

const TransactionHeaderDetails = ({
  data,
  transactionsCount = 0,
  dispatch,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'subscriptions']);
  const [spends, setSpends] = useState({
    ytg: 0,
    nextPayment: null,
    totalPayment: 0,
    trend: 0,
  });
  const gObjProp = (key, defaultValue = '') => objectHelpers.getObjProp(data, key, defaultValue);

  const {totalPayment, ytg} = spends;
  const paymentTrans = t('payment');
  const billType = t(subscriptionsHelpers.getBillType(gObjProp('billed')));

  useEffect(() => {
    if (data) {
      setSpends({
        ytg: data.ytg,
        nextPayment: data.next_payment,
        totalPayment: subscriptionsHelpers.getSubscriptionTotalPayment(data),
        trend: data.trend,
      });
    }
  }, [data]);

  const getPrice = (value) => value ? amountHelpers.getAmountWithCurrencyCode(value) : 'N.A.';

  const getNextPaymentDate = () => subscriptionsHelpers.getNextPaymentDate(data,'DD/MM/YYYY', 'on --/--/----');

  const getTrend = () => {
    const {trend} = spends;
    const isPositive = trend < 0;
    return {
      description: trend === 0 ? 'N.A' : <span className={`trend ${isPositive ? 'success' : 'error'}`}>{isPositive ? '-' : '+'}{Math.abs(trend)}%</span>,
      extra: trend !== 0 ? <DirectionLine direction={isPositive ? 'up' : 'down'} /> : undefined
    }
  }

  const getUsage = () => {
    let variant = subscriptionsHelpers.getUsageVariant(data.logins_count);
    return (
      <Space>
        {t(`serviceUsageStatuses.${variant}`)}
        <StyledTransactionHeaderDetailsUsage
          className='subscription-header-usage'
          variant={variant}
        />
      </Space>
    );
  }

  const transactionDescription = transactionsCount
    ? `${transactionsCount} ${t(transactionsCount > 1 ? 'payments' : 'payment')}`
    : `- ${t('payments')}`;

  const nextPayment = getNextPaymentDate();

  const usage = getUsage();

  return (
    <StyledTransactionHeaderDetails {...rest}>
      <StyledTransactionHeaderDetailsCombinedCounter>
        <TotalCounter
          title={`${t('total')} ${paymentTrans}`}
          value={getPrice(totalPayment)}
          {...getTrend()}
        />

        <TotalCounter
          description={billType}
          title={`${t('next')} ${paymentTrans}`}
          value={nextPayment}
        />
      </StyledTransactionHeaderDetailsCombinedCounter>

      <TotalCounter
        description={t('thisMonth')}
        title={t('subscriptions:usage')}
        value={usage}
      />

      <TotalCounter
        description={transactionDescription}
        title={`${t('spending')} ${t('ytd')}`}
        value={getPrice(ytg)}
      />
    </StyledTransactionHeaderDetails>
  );
}

TransactionHeaderDetails.propTypes = {
  data: PropTypes.shape({
    logins_count: PropTypes.number,
    trend: PropTypes.number.isRequired,
    ytg: PropTypes.number.isRequired,
    next_payment: PropTypes.number,
    total_payment: PropTypes.number
  }),
  transactionsCount: PropTypes.number
}

export default TransactionHeaderDetails;
